import React from 'react';
import ValidatorSummary, { IValidatorDecisionConfig } from 'components/ValidatorSummary';
import { AsyncTaskStatus, ItemSourceSentenceTranslationValidatorItemStatus as ItemStatus } from 'constants/itemSourceSentenceTranslationValidatorStatus';
import ItemSourceSentenceTranslationValidatorItemsModel from 'models/ItemSourceSentenceTranslationValidatorItemsModel';

interface IProps {
  itemsModel: ItemSourceSentenceTranslationValidatorItemsModel;
  onFilterChange: (filter: { type: 'status' | 'decision'; value: string } | null) => void;
  activeFilter: { type: 'status' | 'decision'; value: string } | null;
  onClearFilter: () => void;
}

const ItemSourceSentenceTranslationValidatorSummary: React.FC<IProps> = ({ itemsModel, onFilterChange, activeFilter, onClearFilter }) => {
  const decisions: IValidatorDecisionConfig[] = [
    { key: 'keep', label: 'Keep', color: '#66BB6A' },
    { key: 'change', label: 'Change', color: '#42A5F5' },
    { key: 'cannot_modify', label: 'Cannot modify', color: '#9E9E9E' },
  ];

  const statusConfig = {
    PENDING: ItemStatus.PENDING,
    NEEDS_USER_REVIEW: ItemStatus.NEEDS_USER_REVIEW,
    DONE: ItemStatus.DONE,
  };

  const asyncTaskStatusConfig = {
    FAILED: AsyncTaskStatus.FAILED,
    DEAD_LETTER: AsyncTaskStatus.DEAD_LETTER,
  };

  // Adapter for filter change to match original signature
  const handleFilterChange = (type: string, value: string) => {
    onFilterChange({ type: type as 'status' | 'decision', value });
  };

  const summaryItems = React.useMemo(() => {
    if (!Array.isArray(itemsModel.gridData)) return [];
    return (itemsModel.gridData as any[]).map((item) => {
      if (item?.ai_result?.decision === 'change' && item?.ai_result?.can_modify === false) {
        return {
          ...item,
          ai_result: {
            ...item.ai_result,
            decision: 'cannot_modify',
          },
        };
      }
      return item;
    });
  }, [itemsModel.gridData]);

  // Don't render anything if there are no items
  if (!itemsModel.gridData || itemsModel.gridData.length === 0) {
    return null;
  }

  return (
    <ValidatorSummary
      items={summaryItems || []}
      decisions={decisions}
      statusConfig={statusConfig}
      asyncTaskStatus={asyncTaskStatusConfig}
      onFilterChange={handleFilterChange}
      activeFilter={activeFilter}
      onClearFilter={onClearFilter}
      colors={{
        processing: '#9C27B0',
        review: '#FFA726',
        error: '#E53935',
      }}
    />
  );
};

export default ItemSourceSentenceTranslationValidatorSummary;
